<template>
	<div>
		<v-container pa-0 fluid grid-list-md>
			<v-data-iterator
				:items="jobs"
				:rows-per-page-items="[10]"
				:pagination.sync="pagination"
				:total-items="pagination.totalItems"
				next-icon="arrow_forward_ios"
				prev-icon="arrow_back_ios"
				content-tag="v-layout"
				row
				wrap
			>
				<v-flex
					slot="item"
					slot-scope="props"
					xs12
					sm6
					md4
					lg3
				>
					<v-card
						:class="hasViewed(props.item.viewed_status)"
						@click.stop="determineRoute(props.item)">
                        <v-card-title
                                :class="(props.item.is_archived) ? 'archived' : ''"
                        >
							<h4><a class="break" >{{ props.item.name }}</a></h4>
							<span v-if="props.item.priority || props.item.is_24_hour_rush" class="rush-item">{{getJobPriority(props.item)}}</span>
						</v-card-title>
						<v-divider></v-divider>
						<v-list dense>
							<v-list-tile>
								<v-list-tile-content>Status:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ getJobEnumItemValue('jobStatuses', props.item.status, 'name') }}</v-list-tile-content>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-content>Department:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ getJobEnumItemValue('jobDepartments', props.item.department, 'abbreviation') }}</v-list-tile-content>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-content>Type:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ getJobEnumItemValue('jobTypes', props.item.type, 'name') }}</v-list-tile-content>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-content>Requestor:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ props.item.requestor | f__displayName }}</v-list-tile-content>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-content>Submitted:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ props.item.created_at | f__twoDigitMonthDay }}</v-list-tile-content>
							</v-list-tile>
							<!-- <v-list-group active-class="default-class border" >
								<v-list-tile>
									<v-list-tile-content>First Comp:</v-list-tile-content>
									<v-list-tile-content class="align-end">{{ props.item.date_first_comp | f__twoDigitMonthDay }}</v-list-tile-content>
								</v-list-tile>
								<v-list-tile>
									<v-list-tile-content>Delivery:</v-list-tile-content>
									<v-list-tile-content class="align-end">{{ props.item.date_delivery | f__twoDigitMonthDay }}</v-list-tile-content>
								</v-list-tile>
							</v-list-group> -->
						</v-list>
					</v-card>
				</v-flex>
                <template slot="no-data">
                    <div class="view-global-loading" v-if="viewLoaded==false">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                    <div class="view-global-nodata" v-else>No Results Found</div>
                </template>
			</v-data-iterator>
		</v-container>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import { VUEX_UI_SHOW_RIGHT_DRAWER } from '@/store/constants/ui'
import { VDataIterator } from 'vuetify'
import { VUEX_JOBS_SYNC_PAGINATION } from '@/store/constants/jobs'
export default {
	name: 'jobs-center-cards',

	data:() => ({
		items:[]
	}),

	components: {
		'v-data-iterator': VDataIterator,
	},
	methods: {
		...mapActions({
			applySorting:VUEX_JOBS_SYNC_PAGINATION,
		}),
		hasViewed(viewed_status) {
				if (viewed_status === false) return 'custom-vcard'
				return ''
			},
		determineRoute(item){
			let state = this.getApprovalStatus(item)
			if (!state) {
				this.$router.push({ name: 'job-drawer-stream', params: { jobId: item.id } })
			} else {
				this.$router.push({ name: 'job-drawer-approval', params: { jobId: item.id } })
			}
		},
		getApprovalStatus(item) {
			switch(item.state) {
				case 'pending_print_approval' :
				case 'pending_print_reapproval' :
					return 'print'
                case 'pending_package_approval' :
                case 'pending_package_reapproval' :
                    return 'package'
				case 'pending_exec_approval' :
				case 'pending_exec_reapproval' :
					return 'exec'
				default :
					return null
			}
		}
	},

	computed: {
		...mapState({
			jobs: state => state.jobs.jobs,
			jobsPagination: state => state.jobs.pagination,
            viewLoaded: state => state.jobs.jobsLoaded,
		}),

		...mapGetters({
			currentJobId: 'getJobId',
			getJobEnumItemValue: 'getJobEnumItemValue'
		}),

		pagination: {
			set(data) {
				this.applySorting(data)
			},
			get() { return this.jobsPagination }
		},

		getJobPriority() {
			return (item) => {
				if (item.is_24_hour_rush) return '24Hr'

				let priority = this.getJobEnumItemValue('jobPriorities', item.priority, 'name')
				return (priority !== 'Standard' && priority !== 'Extended') ? priority : ''
			}
		},
	},
}
</script>

<style>
.break {
	word-break: break-all;
}
</style>
